/* eslint-disable @typescript-eslint/no-require-imports */
import { ImageRequireSource } from 'react-native';
import { AccountIconIllustrationMap } from 'shared/components/vxl/AccountIcon/AccountIcon.helpers';

export type IllustrationMapType = typeof IllustrationMap;

const IllustrationMap = {
  ...AccountIconIllustrationMap,
  ADVANCE_A:
    require('assets/illustrations/vxl/advance-a.png') as ImageRequireSource,
  BANK_A: require('assets/illustrations/vxl/bank-a.png') as ImageRequireSource,
  BASICS_A:
    require('assets/illustrations/vxl/basics-a.png') as ImageRequireSource,
  BELIEVE_A:
    require('assets/illustrations/vxl/believe-a.png') as ImageRequireSource,
  BELIEVE_APPROVAL_A_ANIMATED:
    require('assets/illustrations/vxl/believe-approval-a-animated.gif') as ImageRequireSource,
  BELIEVE_CARD_A_ANIMATED:
    require('assets/illustrations/vxl/believe-card-a-animated.gif') as ImageRequireSource,
  BELIEVE_CARD_D:
    require('assets/illustrations/vxl/believe-card-d.png') as ImageRequireSource,
  BELIEVE_DARK_CARD_A_ANIMATED:
    require('assets/illustrations/vxl/believe-dark-card-a-animated.gif') as ImageRequireSource,
  // NOTE: it is not recommended or supported to use the believe-card-front illustration.
  BELIEVE_MAS:
    require('assets/images/vxl/component/digitalCard/believe-card-front.png') as ImageRequireSource,
  BILL_MANAGER_A:
    require('assets/illustrations/vxl/bill-manager-a.png') as ImageRequireSource,
  BILLS_A:
    require('assets/illustrations/vxl/bills-a.png') as ImageRequireSource,
  BINOCULARS_A:
    require('assets/illustrations/vxl/binoculars-a.png') as ImageRequireSource,
  CALCULATOR_A:
    require('assets/illustrations/vxl/calculator-a.png') as ImageRequireSource,
  CALCULATOR_B:
    require('assets/illustrations/vxl/calculator-b.png') as ImageRequireSource,
  CALENDAR_A:
    require('assets/illustrations/vxl/calendar-a.png') as ImageRequireSource,
  CARD_A: require('assets/illustrations/vxl/card-a.png') as ImageRequireSource,
  CARD_A_ANIMATED:
    require('assets/illustrations/vxl/card-a-animated.gif') as ImageRequireSource,
  CARD_B: require('assets/illustrations/vxl/card-b.png') as ImageRequireSource,
  CARD_C: require('assets/illustrations/vxl/card-c.png') as ImageRequireSource,
  CARD_D: require('assets/illustrations/vxl/card-d.png') as ImageRequireSource,
  CARD_SENT_A:
    require('assets/illustrations/vxl/card-sent-a.png') as ImageRequireSource,
  CASH_A: require('assets/illustrations/vxl/cash-a.png') as ImageRequireSource,
  CASH_A_ANIMATED:
    require('assets/illustrations/vxl/cash-a-animated.gif') as ImageRequireSource,
  CASH_B_ANIMATED:
    require('assets/illustrations/vxl/cash-b-animated.gif') as ImageRequireSource,
  CASH_B: require('assets/illustrations/vxl/cash-b.png') as ImageRequireSource,
  CASH_C: require('assets/illustrations/vxl/cash-c.png') as ImageRequireSource,
  CASH_D: require('assets/illustrations/vxl/cash-d.png') as ImageRequireSource,
  CASH_E: require('assets/illustrations/vxl/cash-e.png') as ImageRequireSource,
  CASH_F: require('assets/illustrations/vxl/cash-f.png') as ImageRequireSource,
  CASHAPP_A:
    require('assets/illustrations/vxl/cashapp-a.png') as ImageRequireSource,
  CHECK_A:
    require('assets/illustrations/vxl/check-a.png') as ImageRequireSource,
  ECASH_A:
    require('assets/illustrations/vxl/ecash-a.png') as ImageRequireSource,
  ECASH_B:
    require('assets/illustrations/vxl/ecash-b.png') as ImageRequireSource,
  CHECKING_APPROVAL_A_ANIMATED:
    require('assets/illustrations/vxl/checking-approval-a-animated.gif') as ImageRequireSource,
  COFFEE_A_ANIMATED:
    require('assets/illustrations/vxl/coffee-a-animated.gif') as ImageRequireSource,
  COINS_A:
    require('assets/illustrations/vxl/coins-a.png') as ImageRequireSource,
  COINS_A_ANIMATED:
    require('assets/illustrations/vxl/coins-a-animated.gif') as ImageRequireSource,
  COINS_B:
    require('assets/illustrations/vxl/coins-b.png') as ImageRequireSource,
  COINS_C:
    require('assets/illustrations/vxl/coins-c.png') as ImageRequireSource,
  DEBIT_CARD_A:
    require('assets/illustrations/vxl/debit-card-a.png') as ImageRequireSource,
  DEBIT_CARD_A_ANIMATED:
    require('assets/illustrations/vxl/debit-card-a-animated.gif') as ImageRequireSource,
  DEBIT_CARD_A_STATIC_SQUARE:
    require('assets/illustrations/vxl/debit-card-a-static-square.png') as ImageRequireSource,
  DEBIT_CARD_B:
    require('assets/illustrations/vxl/debit-card-b.png') as ImageRequireSource,
  // NOTE: it's not recommended or supported to use debit-card-front as an illustration.
  DEBIT_CARD_MAS:
    require('assets/images/vxl/component/digitalCard/debit-card-front.png') as ImageRequireSource,
  DISCOBALL_A:
    require('assets/illustrations/vxl/discoball-a.png') as ImageRequireSource,
  FLASHLIGHT_A:
    require('assets/illustrations/vxl/flashlight-a.png') as ImageRequireSource,
  FOOD_A: require('assets/illustrations/vxl/food-a.png') as ImageRequireSource,
  GAUGE_A:
    require('assets/illustrations/vxl/gauge-a.png') as ImageRequireSource,
  GAUGE_B:
    require('assets/illustrations/vxl/gauge-b.png') as ImageRequireSource,
  GAUGE_C:
    require('assets/illustrations/vxl/gauge-c.png') as ImageRequireSource,
  GAUGE_D:
    require('assets/illustrations/vxl/gauge-d.png') as ImageRequireSource,
  GRAPH_A:
    require('assets/illustrations/vxl/graph-a.png') as ImageRequireSource,
  GROCERIES_A:
    require('assets/illustrations/vxl/groceries-a.png') as ImageRequireSource,
  HEALTH_A:
    require('assets/illustrations/vxl/health-a.png') as ImageRequireSource,
  HIGH_FIVE_A:
    require('assets/illustrations/vxl/high-five-a.png') as ImageRequireSource,
  HOURGLASS_A:
    require('assets/illustrations/vxl/hourglass-a.png') as ImageRequireSource,
  ID_A: require('assets/illustrations/vxl/id-a.png') as ImageRequireSource,
  KEYS_A: require('assets/illustrations/vxl/keys-a.png') as ImageRequireSource,
  LOCK_A: require('assets/illustrations/vxl/lock-a.png') as ImageRequireSource,
  LOADING_CIRCLE_STATIC:
    require('assets/illustrations/vxl/loading-circle-static.png') as ImageRequireSource,
  LOADING_COIN_ANIMATED:
    require('assets/illustrations/vxl/loading-coin-animated.gif') as ImageRequireSource,
  MAGNIFY_A:
    require('assets/illustrations/vxl/magnify-a.png') as ImageRequireSource,
  MONEYBAG_A:
    require('assets/illustrations/vxl/moneybag-a.png') as ImageRequireSource,
  NOTIFICATION_A:
    require('assets/illustrations/vxl/notification-a.png') as ImageRequireSource,
  OFFERS_A:
    require('assets/illustrations/vxl/offers-a.png') as ImageRequireSource,
  OFFERS_B:
    require('assets/illustrations/vxl/offers-b.png') as ImageRequireSource,
  PAYCHECK_A:
    require('assets/illustrations/vxl/paycheck-a.png') as ImageRequireSource,
  PAYLATER_A:
    require('assets/illustrations/vxl/paylater-a.png') as ImageRequireSource,
  PHONE_A:
    require('assets/illustrations/vxl/phone-a.png') as ImageRequireSource,
  PHONE_B:
    require('assets/illustrations/vxl/phone-b.png') as ImageRequireSource,
  PAID_OFF_A_ANIMATED:
    require('assets/illustrations/vxl/paid-off-a-animated.gif') as ImageRequireSource,
  PHONE_A_ANIMATED:
    require('assets/illustrations/vxl/phone-a-animated.gif') as ImageRequireSource,
  PIGGY_BANK_A:
    require('assets/illustrations/vxl/piggy-bank-a.png') as ImageRequireSource,
  PLACEHOLDER_A:
    require('assets/illustrations/vxl/placeholder-a.png') as ImageRequireSource,
  PLANE_A:
    require('assets/illustrations/vxl/plane-a.png') as ImageRequireSource,
  PLANE_A_ANIMATED:
    require('assets/illustrations/vxl/plane-a-animated.gif') as ImageRequireSource,
  PLANE_B:
    require('assets/illustrations/vxl/plane-b.png') as ImageRequireSource,
  PLANE_C:
    require('assets/illustrations/vxl/plane-c.png') as ImageRequireSource,
  SAVINGS_APPROVAL_A_ANIMATED:
    require('assets/illustrations/vxl/savings-approval-a-animated.gif') as ImageRequireSource,
  SEND_MONEY_A:
    require('assets/illustrations/vxl/send-money-a.png') as ImageRequireSource,
  SEND_MONEY_ANYONE_A_ANIMATED:
    require('assets/illustrations/vxl/send-money-anyone-a-animated.gif') as ImageRequireSource,
  SHIELD_A:
    require('assets/illustrations/vxl/shield-a.png') as ImageRequireSource,
  SHOPPING_A:
    require('assets/illustrations/vxl/shopping-a.png') as ImageRequireSource,
  SIGN_A: require('assets/illustrations/vxl/sign-a.png') as ImageRequireSource,
  SIGN_B: require('assets/illustrations/vxl/sign-b.png') as ImageRequireSource,
  TOGGLE_A:
    require('assets/illustrations/vxl/toggle-a.png') as ImageRequireSource,
  TOGGLE_B:
    require('assets/illustrations/vxl/toggle-b.png') as ImageRequireSource,
  TRANSPORTATION_A:
    require('assets/illustrations/vxl/transportation-a.png') as ImageRequireSource,
  TRAVEL_A:
    require('assets/illustrations/vxl/travel-a.png') as ImageRequireSource,
  VENMO_A:
    require('assets/illustrations/vxl/venmo-a.png') as ImageRequireSource,
  VLOC_A: require('assets/illustrations/vxl/vloc-a.png') as ImageRequireSource,
  WALLET_A_ANIMATED:
    require('assets/illustrations/vxl/wallet-a-animated.gif') as ImageRequireSource,
  WALLET_B:
    require('assets/illustrations/vxl/wallet-b.png') as ImageRequireSource,
  ZELLE:
    require('assets/images/vxl/logos/zelle/zelle-logo.png') as ImageRequireSource, // TODO: Remove this from the illustration map once we have a permanent solution in place
} satisfies Record<string, ImageRequireSource>;

export default IllustrationMap;
